/**
 * FT10-U16: Withholding Tax Register with remittance create and post (FSD 2.2.2.10,
 * FIN-FR-006). The INT packet spreads `AP_WITHHOLDING_ROUTES` and adds nav item
 * `ap-withholding` (p02). The route's permission is the register endpoint's: `ap.wht.read`.
 */

import type { RouteRecordRaw } from 'vue-router'

import { WITHHOLDING_PERMISSIONS } from './api'

export const AP_WITHHOLDING_ROUTES: RouteRecordRaw[] = [
  {
    path: '/ap/reports/withholding',
    name: 'ap-withholding',
    component: () => import('@/modules/ap/reports/withholding/WithholdingView.vue'),
    meta: {
      titleKey: 'ap.routeTitles.withholding',
      permission: WITHHOLDING_PERMISSIONS.whtRead,
    },
  },
]
